import Preloader from '../scenes/Preloader';
import HUD from '../scenes/HUD';
import PopUpWindow from '../scenes/PopUpWindow';
import Battle from '../scenes/Battle';
import MapScene from '../scenes/MapScene';

const createNewMap = (key) => {
  return class Map extends MapScene {
    constructor() {
      super(key, key);
    }

    create() {}
  };
};

export const createMapsBasedOnLoadedMapsConfig = (scene, MAPS_CONFIG) => {
  for (const key in MAPS_CONFIG) {    
    scene.game.scene.add(MAPS_CONFIG[key].key, createNewMap(MAPS_CONFIG[key].key));
  }
};

export const scenes = [Preloader, HUD, PopUpWindow, Battle];
